export default __webpack_public_path__ + "static/media/check.575d1176.svg";